export const conetent = {
    position: "inherit",
    width: "95%",
    margin: "0 auto"
};